export const CATEGORIES_LIST_REQUESTING = 'categories/CATEGORIES_LIST_REQUESTING';
export const CATEGORIES_LIST_SUCCESS = 'categories/CATEGORIES_LIST_SUCCESS';
export const CATEGORIES_LIST_FAILED = 'categories/CATEGORIES_LIST_FAILED';
export const CATEGORIES_REQUESTING = 'categories/CATEGORIES_REQUESTING';
export const CATEGORIES_SUCCESS = 'categories/CATEGORIES_SUCCESS';
export const CATEGORIES_FAILED = 'categories/CATEGORIES_FAILED';